import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Utils from "@utils";
import { ProjectService } from "@services";
import { ReactSelect, Modal } from "../../../../../components";

import "./QuickAddProjectModal.scss";

class QuickAddProjectModal extends Component {
	constructor(props) {
		const { lang } = global;
		super(props);
		this.initialState = {
			agencyContacts: [],
			projectName: "",
			projectNameError: false,
			agencySupervisor: { label: "", value: "" },
			paymentTerms: { label: "", value: "" },
			description: "",
		};

		this.state = { ...this.initialState };

		this.PaymentTerms = [
			{ value: 10, label: lang.t("On Site") },
			{ value: 20, label: lang.t("dynamic.Net number", { number: "15" }) },
			{ value: 30, label: lang.t("dynamic.Net number", { number: "30" }) },
			{ value: 40, label: lang.t("dynamic.Net number", { number: "60" }) },
			{ value: 50, label: lang.t("dynamic.Net number", { number: "90" }) },
		];
	}

	onProjectSave = () => {
		const { lang } = global;
		const { projectName, paymentTerms, agencySupervisor, description } = this.state;
		const { clientId, successCallback, closeModal } = this.props;

		this.setState({
			projectNameError: projectName === "",
		});

		if (projectName) {
			ProjectService.save({
				projectName,
				projectNumber: "",
				clientSupervisor: "",
				agencySupervisor: agencySupervisor.value,
				agencySupervisorName: agencySupervisor.label,
				additionalAgencyContact: [],
				paymentTerms: paymentTerms.value,
				description,
				status: 1,
				client: clientId,
			})
				.then(() => {
					Utils.notify({
						type: "success",
						message: lang.t("Project sucessfully created"),
					});
					this.setState(this.initialState, () => successCallback(clientId));
					closeModal();
				})
				.catch(() => {
					Utils.notify({
						type: "error",
						message: lang.t("Error creating Project"),
						title: "Error",
					});
				});
		}
	};

	/**
	 * Handles all input changes for creating a project
	 * @param {Event} event The HTML event handled by this method
	 * @param {String} property The property to update
	 */
	handleInputChange = (event, property) => {
		let value;
		let name;
		// On select box the value is an object itself, so we assign that to the value if we see 'agencySupervisor or paymentTerms otherwise just use name/val.
		if (property === "agencySupervisor" || property === "paymentTerms") {
			value = event || "";
			name = property || "";
		} else
			({
				target: { name, value },
			} = event);

		this.setState({ [name]: value });
	};

	//	destructured values below so its easier to identify.
	render() {
		const { lang } = global;
		const { agencySupervisor, description, projectName, paymentTerms, projectNameError } =
			this.state;
		const { show, closeModal, clientName, agencyContacts } = this.props;

		return (
			<Modal
				show={show}
				onHide={() => this.setState(this.initialState)}
				id="quick-add-project-modal"
			>
				<Modal.Header>
					<Modal.Title>{lang.t("Add Project")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-horizontal">
						<div className="row form-group">
							<label
								htmlFor="clientName"
								className="col-xs-3 col-sm-4 control-label"
							>
								{lang.t("Client")}:
							</label>
							<div className="col-xs-6 client-name">{clientName}</div>
						</div>
						<div className="row form-group">
							<label
								htmlFor="project-name"
								className="col-sm-4 control-label"
							>
								{lang.t("Project")}:
							</label>
							<div className="col-sm-6">
								<input
									name="projectName"
									type="text"
									id="projectName"
									data-test-id="project-form__name"
									className={classNames("form-control", {
										"has-error": projectNameError,
									})}
									value={projectName}
									onChange={event => this.handleInputChange(event)}
									onKeyPress={({ key }) => {
										if (key === "Enter") this.onProjectSave();
									}}
								/>
							</div>
						</div>
						<div className="row form-group">
							<label
								htmlFor="projectAgencySupervisor"
								className="col-sm-4 control-label"
							>
								{lang.t("Agency Supervisor")}:
							</label>
							<div className="col-sm-6">
								<ReactSelect
									name="agencySupervisor"
									id="agencySupervisor"
									dataTestId="project-form__agency-supervisor"
									value={agencySupervisor.value}
									onChange={event =>
										this.handleInputChange(event, "agencySupervisor")
									}
									options={agencyContacts}
									isClearable
								/>
							</div>
						</div>
						<div className="row form-group">
							<label
								htmlFor="projectPaymentTerms"
								className="col-sm-4 control-label"
							>
								{lang.t("Payment Terms")}:
							</label>
							<div className="col-sm-6">
								<ReactSelect
									name="paymentTerms"
									id="paymentTerms"
									dataTestId="project-form__payment-terms"
									value={paymentTerms.value}
									onChange={event =>
										this.handleInputChange(event, "paymentTerms")
									}
									options={this.PaymentTerms}
									isClearable
								/>
							</div>
						</div>
						<div className="row form-group">
							<label
								htmlFor="projectDescription"
								className="col-sm-4 control-label"
							>
								{lang.t("Description")}:
							</label>
							<div className="col-sm-6">
								<textarea
									name="description"
									id="description"
									data-test-id="project-form__description"
									className="form-control"
									value={description}
									onChange={event => this.handleInputChange(event)}
								/>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						id="quick-add-project-cancel"
						data-test-id="quick-add-project__cancel"
						type="button"
						onClick={closeModal}
						className="btn btn-link"
						title="Cancel"
					>
						{lang.t("Cancel")}
					</button>
					<button
						id="quick-add-project"
						data-test-id="quick-add-project__save"
						type="button"
						onClick={this.onProjectSave}
						className="btn btn-primary"
						title="Save"
					>
						{lang.t("Save")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

QuickAddProjectModal.propTypes = {
	show: PropTypes.bool,
	closeModal: PropTypes.func,
	clientName: PropTypes.string,
	successCallback: PropTypes.func,
	clientId: PropTypes.number,
	agencyContacts: PropTypes.array,
};
QuickAddProjectModal.defaultProps = {
	successCallback: () => {},
	clientId: undefined,
	closeModal: () => {},
	clientName: "",
	show: false,
	agencyContacts: [],
};

export default QuickAddProjectModal;
